import moment, { Moment } from 'moment';
import { ThemeType, useLocalTheme } from '../../../hooks/useLocalTheme';

export const BLUE = { r: 51, g: 153, b: 255 };
export const DARK_BLUE = { r: 25, g: 78, b: 180 };
export const RED = { r: 255, g: 0, b: 0 };
export const DARK_RED = { r: 120, g: 20, b: 20 };
export const ORANGE = { r: 233, g: 131, b: 0 };
export const DARK_ORANGE = { r: 160, g: 100, b: 10 };
export const GREEN = { r: 10, g: 230, b: 0 };
export const DARK_GREEN = { r: 15, g: 180, b: 10 };
export const YELLOW = { r: 249, g: 215, b: 28 };
export const GRAY = { r: 112, g: 112, b: 112 };

export const getColorForColumn = (
  value: number,
  plan: number,
  granularity: number,
  granularityUnit: number,
  intervalStart: Moment,
  qtyLevelOrange: number,
  qtyLevelGreen: number,
  localTheme?: ThemeType,
) => {
  const numberOfUnits = granularity * granularityUnit;
  const currentUnit =
    Math.abs(moment().utc().get('minutes') - intervalStart!.get('minutes')) * granularityUnit;
  plan = (plan / numberOfUnits) * currentUnit;

  let _color = localTheme === ThemeType.DARK ? DARK_RED : RED;
  let planKoef = value / plan;
  if (planKoef > qtyLevelOrange && planKoef < qtyLevelGreen)
    _color = localTheme === ThemeType.DARK ? DARK_ORANGE : ORANGE;
  if (planKoef > qtyLevelGreen) _color = localTheme === ThemeType.DARK ? DARK_GREEN : GREEN;
  return _color;
};

export const getColorForHistoryColumn = (
  value: number,
  plan: number,
  qtyLevelOrange?: number,
  qtyLevelGreen?: number,
  localTheme?: ThemeType,
) => {
  let _color = localTheme === ThemeType.DARK ? DARK_RED : RED;
  let planKoef = value / plan;
  if (qtyLevelOrange && qtyLevelGreen) {
    if (plan === 0) _color = localTheme === ThemeType.DARK ? DARK_GREEN : GREEN;
    if (planKoef > qtyLevelOrange && planKoef < qtyLevelGreen)
      _color = localTheme === ThemeType.DARK ? DARK_ORANGE : ORANGE;
    if (planKoef > qtyLevelGreen) _color = localTheme === ThemeType.DARK ? DARK_GREEN : GREEN;
  }
  return _color;
};
